import { apiSlice } from '../api/api-slice';
import { StaffInfoListResponse } from 'types/add-staff-user/admin-staff-list';

const staffListApi = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        staffList: builder.query<StaffInfoListResponse[], void>({
            query: () => ({
                url: '/admin/list',
                method: 'GET',
            }),
        }),
    }),
});
export const { useStaffListQuery } = staffListApi;
